<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">监测点名称：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">关联设备：</span>
        </div>
        <el-select v-model="equipmentCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请选择关联设备">
          <el-option v-for="item in equipmentList" :key="item.deviceCode"
                     :label="item.deviceName" :value="item.deviceCode">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>
    </form>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/FaceRecognition";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "monitor-point-management-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "人脸应用",
          name: "monitoring-point-management"
        },
        {
          value: "监测点管理"
        }
      ],
      mainTitle: "添加监测点",
      subheading: "",
      formData: {},
      equipmentCode: "",
      equipmentList: []
    };
  },
  created() {
    this.remoteMethod();
  },
  methods: {
    remoteMethod() {
      this.getVideoDeviceList();
    },
    confirm() {
      if (!this.formData.name) {
        nError("请输入监测点名称");
        return false;
      }
      if (!this.formData.deviceCode) {
        nError("请选择关联设备");
        return false;
      }
      this.$axios
        .post(api.addFacePoint, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "monitoring-point-management"
            });
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.$router.push({
        name: "monitoring-point-management"
      });
    },
    getVideoDeviceList() {
      this.$axios
        .post(api.getVideoDeviceList, { purpose: "人脸识别" })
        .then(res => {
          this.equipmentList = res.data.data;
        })
        .catch(errorHandler("获取列表失败"));
    }
  },
  watch: {
    equipmentCode(val) {
      this.equipmentList.map(v => {
        if (v.deviceCode == val) {
          this.formData.deviceCode = v.deviceCode;
          this.formData.deviceName = v.deviceName;
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/FaceRecognition/MonitoringPointManagement/MonitoringPointManagementAdd.vue